import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '& .confirmation': {
      '&-title': {
        '&-container': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: theme.spacing(3, 0, 1),
        },
        '&-icon': {
          fontSize: theme.spacing(6),
          marginTop: theme.spacing(1),
        },
        '&-text': {
          textAlign: 'center',
          margin: theme.spacing(2, 0, 0),
          padding: theme.spacing(0, 3),
        },
      },
      '&-description': {
        '&-text': {
          textAlign: 'left',
          color: theme.palette.text.hint,
          padding: theme.spacing(0, 2, 2),
        },
      },
      '&-action': {
        '&-cancel': {
          color: theme.palette.secondary.main,
        },
      },
    },
    '&.error': {
      '& .confirmation': {
        '&-title-icon, &-action-confirm': {
          color: theme.palette.custom.feedback.negative,
        },
      },
    },
    '&.warning': {
      '& .confirmation': {
        '&-title-icon, &-action-confirm': {
          color: theme.palette.custom.feedback.warning,
        },
      },
    },
    '&.success': {
      '& .confirmation': {
        '&-title-icon, &-action-confirm': {
          color: theme.palette.custom.feedback.positive,
        },
      },
    },
  },
}));

export default styles;
